import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText, } from '@fortawesome/vue-fontawesome';
import { merge } from 'lodash';
var items = {
    disabled: { type: Boolean },
    left: { type: Boolean },
    right: { type: Boolean },
    small: { type: Boolean },
    large: { type: Boolean },
};
merge(FontAwesomeIcon.props, items);
FontAwesomeIcon.render = wrap(FontAwesomeIcon.render);
// augment to make it behave like icons
function wrap(fn) {
    return function (createElement, context) {
        if (!context.data.staticClass)
            context.data.staticClass = 'v-icon';
        else if (!context.data.staticClass.includes('v-icon'))
            context.data.staticClass += ' v-icon';
        merge(context.data, {
            class: {
                'v-icon--disabled': p(context, 'disabled'),
                'v-icon--left': p(context, 'left'),
                'v-icon--link': context.data.on && (context.data.on.click || context.data.on['!click']),
                'v-icon--right': p(context, 'right'),
                'v-icon--small': p(context, 'small'),
                'v-icon--large': p(context, 'large'),
            },
            attrs: {
                'aria-hidden': true,
            },
        });
        return fn.call(this, createElement, context);
    };
    function p(context, name) {
        if (context.parent && context.parent.$props) {
            return context.parent.$props.hasOwnProperty(name)
                ? context.parent.$props[name]
                : context.props[name];
        }
        return undefined;
    }
}
export { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText };
//# sourceMappingURL=fontAwesomeWrapper.js.map